export * from 'components/Phantom/_pageCompositions/Shop/Shop'
